import React, { useState, useEffect } from 'react';
import sidebarData from '../LayoutMenuDataV2';
import { Link, useLocation } from 'react-router-dom';
import { Collapse } from 'reactstrap';

const VerticalSidebar = () => {
  const location = useLocation();
  const [activeMenus, setActiveMenus] = useState({});
  const [activeLinkId, setActiveLinkId] = useState(null);

  const navData = sidebarData()?.props?.children || [];

  // Auto-expand parents if current route matches a subItem
  useEffect(() => {
    const expandActiveMenus = (items, path, openMenus = {}) => {
      for (const item of items) {
        if (item.subItems && item.subItems.length > 0) {
          const childResult = expandActiveMenus(item.subItems, path, openMenus);
          if (childResult.found) {
            openMenus[item.id] = true;
            return { found: true, openMenus };
          }
        }
        if (item.link && path.startsWith(item.link) && item.link !== '#') {
          return { found: true, openMenus };
        }
      }
      return { found: false, openMenus };
    };

    const { openMenus } = expandActiveMenus(navData, location.pathname);
    setActiveMenus(openMenus);
  }, [location.pathname]);

  const toggleMenu = id => {
    const findItemAndCollapseChildren = (targetId, items) => {
      for (const item of items) {
        if (item.id === targetId) {
          return collectAllChildIds(item);
        }
        if (item.subItems?.length) {
          const result = findItemAndCollapseChildren(targetId, item.subItems);
          if (result.length) return result;
        }
      }
      return [];
    };

    const collectAllChildIds = item => {
      let ids = [];
      if (item.subItems?.length) {
        for (const child of item.subItems) {
          ids.push(child.id);
          ids = ids.concat(collectAllChildIds(child));
        }
      }
      return ids;
    };

    setActiveMenus(prev => {
      const isCurrentlyOpen = prev[id];
      const newState = { ...prev, [id]: !isCurrentlyOpen };

      if (isCurrentlyOpen) {
        // Collapse all children recursively
        const childIds = findItemAndCollapseChildren(id, navData);
        for (const childId of childIds) {
          newState[childId] = false;
        }
      }

      return newState;
    });
  };

  return (
    <>
      {navData.map((item, idx) => (
        <div className="mb-4">
          <p className="px-3 m-0 fs-12 fw-semibold" style={{ color: 'rgba(255, 255, 255, 1)' }}>
            {item?.label}
          </p>
          <ul className="navbar-nav" id="navbar-nav">
            {item?.subItems?.map(subItem => {
              return (
                <SidebarMenuItem
                  key={subItem.id || idx}
                  item={subItem}
                  toggleMenu={toggleMenu}
                  activeMenus={activeMenus}
                  activeLinkId={activeLinkId}
                  setActiveLinkId={setActiveLinkId}
                />
              );
            })}
          </ul>
        </div>
      ))}
    </>
  );
};

export default VerticalSidebar;

const SidebarMenuItem = ({ item, toggleMenu, activeMenus, activeLinkId, setActiveLinkId, depth = 0 }) => {
  const isOpen = activeMenus[item.id];
  const hasChildren = item.subItems?.length > 0;
  const isActive = activeLinkId === item.id;

  return (
    <li className="nav-item">
      <Link
        to={item.link || '#'}
        className={`nav-link menu-link ${isActive ? 'active' : ''}`}
        onClick={e => {
          if (hasChildren) {
            e.preventDefault();
            toggleMenu(item.id);
          } else {
            setActiveLinkId(item.id);
          }
        }}
      >
        {depth === 0 && item.icon && <i className={item.icon}></i>}
        <span className={`${depth === 0 && 'fw-semibold'}`}>{item.label}</span>
        {hasChildren && (
          <span className="ms-auto">
            {isOpen ? <i className="ri-arrow-down-s-line fs-14 mt-1"></i> : <i className="ri-arrow-right-s-line fs-14 mt-1"></i>}
          </span>
        )}
      </Link>

      {hasChildren && (
        <Collapse isOpen={isOpen} className="menu-dropdown">
          <ul className="nav nav-sm flex-column">
            {item.subItems.map((child, idx) => (
              <SidebarMenuItem
                key={child.id || idx}
                item={child}
                toggleMenu={toggleMenu}
                activeMenus={activeMenus}
                depth={depth + 1}
                activeLinkId={activeLinkId}
                setActiveLinkId={setActiveLinkId}
              />
            ))}
          </ul>
        </Collapse>
      )}
    </li>
  );
};
